import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { useRef, useState, useEffect } from 'react';
import '../../../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import MenuSearchBox from '../c9c241bbc5c318c31f8d823e499ee2905dd096eed5628b5d8d736144942ad32b.cfe-internal.js';
import '../../../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import mergeRefs from '../../../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import wrapEvent from '../../../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';
import useLatest from '../../../../hooks/useLatest/1f51704b192f9e30a9862fa17b105c3f6454cca23cf8d6fb114db55de1c4e301.cfe-internal.js';
import { SUBMENU_POPPER_OFFSET, FLYOUT_POPPER_OFFSET } from '../../../../utils/f5e4d8f62716db08736bdf8cd2bfb32640bfafeca586ef59cc354009b4870444.cfe-internal.js';

var _excluded = ["role", "tabIndex", "highlightedIndex", "onHighlightedIndexChange", "children", "searchBoxRef", "anchorRef", "isSubmenu", "onKeyDown", "isNavItem", "maxHeight", "minWidth", "searchable", "menuItemContainerClass", "searchTerm", "setSearchTerm", "data-popper-ready", "style"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function useChildrenRefs(children, getAdditionalProps, isNavItem, searchable) {
  var _context;
  var refs = useRef({});
  // eslint-disable-next-line no-return-assign
  var createRefCallback = function createRefCallback(index) {
    return function (node) {
      return refs.current[index] = node;
    };
  };
  var refIndex = searchable ? 1 : 0;
  var allChildren = _mapInstanceProperty(_context = React__default.Children).call(_context, children, function (child) {
    if (isNavItem(child)) {
      var myIndex = refIndex;
      refIndex += 1;
      var additionalProps = getAdditionalProps(child, myIndex);
      return /*#__PURE__*/React__default.cloneElement(child, _objectSpread({
        ref: mergeRefs(createRefCallback(myIndex), child.ref)
      }, additionalProps));
    }
    return child;
  });
  refs.current.length = refIndex;
  return [refs, allChildren];
}
var ArrowNav = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var role = _ref.role,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex,
    highlightedIndex = _ref.highlightedIndex,
    onHighlightedIndexChange = _ref.onHighlightedIndexChange,
    children = _ref.children,
    searchBoxRef = _ref.searchBoxRef,
    anchorRef = _ref.anchorRef,
    isSubmenu = _ref.isSubmenu,
    onKeyDown = _ref.onKeyDown,
    _ref$isNavItem = _ref.isNavItem,
    isNavItem = _ref$isNavItem === void 0 ? function () {
      return true;
    } : _ref$isNavItem,
    maxHeight = _ref.maxHeight,
    minWidth = _ref.minWidth,
    searchable = _ref.searchable,
    menuItemContainerClass = _ref.menuItemContainerClass,
    searchTerm = _ref.searchTerm,
    setSearchTerm = _ref.setSearchTerm,
    isPopperReady = _ref['data-popper-ready'],
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isKeyboardUser = _useState2[0],
    setIsKeyboardUser = _useState2[1];
  var containerRef = useRef(null);
  var menuItemContainerRef = useRef(null);
  var _useChildrenRefs = useChildrenRefs(children, function (child, index) {
      return {
        tabIndex: -1,
        onMouseEnter: wrapEvent(child.props.onMouseEnter, function () {
          setIsKeyboardUser(false);
          onHighlightedIndexChange(index);
        })
      };
    }, isNavItem, searchable),
    _useChildrenRefs2 = _slicedToArray(_useChildrenRefs, 2),
    refs = _useChildrenRefs2[0],
    allChildren = _useChildrenRefs2[1];
  var isKeyboardUserRef = useLatest(isKeyboardUser);

  // Update the focused menu item when the highlighted index changes
  useEffect(function () {
    if (isPopperReady) {
      if (refs.current[highlightedIndex]) {
        // Scroll the item into view when navigating with a keyboard
        var element = refs.current[highlightedIndex];
        if (isKeyboardUserRef.current && menuItemContainerRef.current) {
          var scrollBottom = menuItemContainerRef.current.clientHeight + menuItemContainerRef.current.scrollTop;
          var elementBottom = element.offsetTop + element.offsetHeight;
          if (elementBottom > scrollBottom) {
            menuItemContainerRef.current.scrollTop = elementBottom - menuItemContainerRef.current.clientHeight;
          } else if (element.offsetTop < menuItemContainerRef.current.scrollTop) {
            menuItemContainerRef.current.scrollTop = element.offsetTop;
          }
        }
        /* preventScroll isn't strictly needed, and doesn't do anything in Safari/IE11.
         * For keyboard users it makes no difference since the item is already in view when .focus() is called.
         * For mouse users, it prevents scrolling from occurring when hovering over a menu item that is partially out of view.
         */
        element.focus({
          preventScroll: true
        });
      } else if (highlightedIndex === 0 && searchable) {
        searchBoxRef === null || searchBoxRef === void 0 || searchBoxRef.current.focus();
      } else {
        var _anchorRef$current;
        anchorRef === null || anchorRef === void 0 || (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 || _anchorRef$current.focus();
      }
    }
  }, [highlightedIndex, refs, searchable, allChildren.length,
  // Needed to prevent QuickSearch from losing focus in some cases when items are loaded asynchronously while the user is navigating
  isPopperReady, isKeyboardUserRef, searchBoxRef, anchorRef]);
  var numChildren = refs.current.length;
  var handleKeyDown = function handleKeyDown(e) {
    setIsKeyboardUser(true);
    if (e.key === 'ArrowDown') {
      e.preventDefault(); // prevent scroll
      if (highlightedIndex !== -1) {
        onHighlightedIndexChange((highlightedIndex + 1) % numChildren);
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault(); // prevent scroll
      if (highlightedIndex !== -1) {
        onHighlightedIndexChange((highlightedIndex - 1 + numChildren) % numChildren);
      }
    } else if (e.key === 'PageUp' || e.key === 'Home') {
      var _containerRef$current;
      // Only call the highlighted index change handler for the current nav list (i.e. if the event bubbles up to a parent nav list, don't call the highlighted index change handler on the parent nav list)
      if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) {
        onHighlightedIndexChange(0);
      }
    } else if (e.key === 'PageDown' || e.key === 'End') {
      var _containerRef$current2;
      // Only call the highlighted index change handler for the current nav list (i.e. if the event bubbles up to a parent nav list, don't call the highlighted index change handler on the parent nav list)
      if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(e.target)) {
        var lastIndex = numChildren - 1;
        onHighlightedIndexChange(lastIndex);
      }
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", _extends({
      ref: mergeRefs(containerRef, ref),
      role: role,
      tabIndex: tabIndex,
      onKeyDown: wrapEvent(onKeyDown, handleKeyDown),
      "data-popper-ready": isPopperReady,
      style: _objectSpread(_objectSpread({}, style), {}, {
        minWidth: minWidth
      })
    }, rest), searchable && /*#__PURE__*/React__default.createElement(MenuSearchBox, {
      value: searchTerm,
      ref: searchBoxRef,
      onChange: function onChange(e) {
        setSearchTerm === null || setSearchTerm === void 0 || setSearchTerm(e.target.value);
      },
      onFocus: function onFocus() {
        return onHighlightedIndexChange(0);
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      role: "presentation",
      style: {
        maxHeight: maxHeight !== null && maxHeight !== void 0 ? maxHeight :
        // This logic is located here instead of BaseMenu.js so the maxHeight will update with screen resizing (Popper has a resize listener that causes this to rerender)
        Math.min(350, (isSubmenu ?
        // Submenus: window height - submenu popper offset - 8px of container padding - half of anchor height (fallback to default 18px))
        document.documentElement.clientHeight - SUBMENU_POPPER_OFFSET[0] :
        // Menus: half of window height - menu popper offset - 8px of container padding - half of anchor height (fallback to default 18px)
        document.documentElement.clientHeight / 2 - FLYOUT_POPPER_OFFSET[1]) - 8 - (anchorRef !== null && anchorRef !== void 0 && anchorRef.current ? anchorRef.current.offsetHeight / 2 : 18))
      },
      className: menuItemContainerClass,
      ref: menuItemContainerRef
    }, allChildren))
  );
});

export { ArrowNav as default };
